module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABHNCSVQICAgIfAhkiAAAATZJREFUSEvtlrFRQ0EMRN92QAdQAlSAqQBCyExECFSAqQATEuEMMuMKMBVACdCBqWAZ/fnM3Hhszyn48GdA8Uor6W4lyfYIuKJ7u5Y0km0DL8C8Q84BsK+wlrBh74rwu4u/T2h7FzhcqvRW0sL2FnCe7MJM0tvaCm1fADdF0E9g0DrFOzwnCS8ljfvT0mT21fBVFd4BD9UR8sAT4Kz8pR/Adj5OtUcTvySMCh+r3fPA4+UK/47wQ2vlIF8AoaV32zvAfbKbMTSeNgn/CAjxlzYsCCdJwvFGwmSwangvJs0MeK1OOQ/ci6XwL/x849Z49OLTNKPNduhwWiQawj9oF3BcA7GAY/PX2qmkySbhR9AgLS3EGydGTJphLVOLm0ua96elyeyr4asqjCO460M4jrHmEP7RU/8LsZobLIMY07sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-nav-icon-active-03.png
// module id = FaJz
// module chunks = 1